export const PDP_GET_RATES = 'PDP_GET_RATES';
export const PDP_SET_PRODUCT = 'PDP_SET_PRODUCT';
export const PDP_SET_ADDED_QTY = 'PDP_SET_ADDED_QTY'
export const SET_RATES_LOADING_FLAG = 'SET_RATES_LOADING_FLAG';
export const SET_ALTERNATE_ITEMS_RATES_LOADED = 'SET_ALTERNATE_ITEMS_RATES_LOADED';
export const SET_ALTERNATE_INVENTORY = 'SET_ALTERNATE_INVENTORY';
export const SET_PARENT_LINK = 'SET_PARENT_LINK';